"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Horizontal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _all = require("gsap/all");

var _styles = require("./styles");

var _bricksUtils = require("@titelmedia/bricks-utils");

var _lodash = require("lodash");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

_all.gsap.registerPlugin(_all.ScrollTrigger);

var Horizontal = function Horizontal(_ref) {
  var items = _ref.items;
  var tlRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var triggerRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);

  var _ref2 = (0, _bricksUtils.useWindowSize)(),
      windowSize = _ref2.windowSize;

  (0, _react.useEffect)(function () {
    return function () {
      if (tlRef.current) {
        tlRef.current.kill();
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    var onResize = (0, _lodash.debounce)(buildTimeline, 500);

    if ((windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) > 0) {
      onResize();
    }
  }, [windowSize]);

  var buildTimeline = function buildTimeline() {
    var _containerRef$current, _containerRef$current2;

    if (tlRef.current) {
      tlRef.current.clear();
      containerRef.current && _all.gsap.set(containerRef.current, {
        x: 0
      });
    }

    tlRef.current = _all.gsap.timeline({
      scrollTrigger: {
        trigger: triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current,
        start: 'top top',
        end: "+=".concat(containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth),
        scrub: true,
        pin: true
      }
    }).to(containerRef.current, {
      x: "-".concat((containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetWidth) - windowSize.width, "px"),
      ease: 'power1.inOut'
    });
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    ref: triggerRef
  }, _react.default.createElement(_styles.Wrapper, {
    ref: wrapperRef
  }, _react.default.createElement(_styles.ContainerDiv, {
    ref: containerRef
  }, items && items.map(function (item, i) {
    return _react.default.createElement(_styles.ImageWrapper, {
      key: "image--".concat(i),
      aspectRatio: item.aspectRatio
    }, _react.default.createElement(_styles.Image, {
      src: item.src,
      srcSet: item.srcSet,
      alt: item.src
    }));
  })))));
};

exports.Horizontal = Horizontal;